export default __webpack_public_path__ + "static/media/cfx-cm-2.9281ee5a.png";